namespace Matrix.Indexation {
    export interface IndexationProfileSecurityRow {
        IndexationProfileCode?: string;
        SecurityId?: number;
        IndexCode?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        DefaultSortOrder?: number;
        IndexationProfileName?: string;
        IndexationProfileIndexationInstanceId?: string;
        IndexationProfileEffectiveDate?: string;
        IndexationProfileValidFrom?: string;
        IndexationProfileValidTo?: string;
        IndexationProfileShortName?: string;
        IndexationProfileRowId?: number;
        IndexationProfileDefaultSortOrder?: number;
        SecurityCode?: string;
        SecurityName?: string;
        SecurityRowId?: number;
        IndexName?: string;
        IndexLocalCurrencyCode?: string;
        IndexTypeCode?: string;
        IndexPriceSource1?: string;
        IndexPriceSource1Id?: string;
        IndexPriceSource2?: string;
        IndexPriceSource2Id?: string;
        IndexFxOtherCurrency?: string;
        IndexRowId?: number;
        IndexDefaultSortOrder?: number;
    }

    export namespace IndexationProfileSecurityRow {
        export const idProperty = 'RowId';
        export const localTextPrefix = 'Indexation.IndexationProfileSecurity';
        export const deletePermission = 'DataAdmin:IndexationProfileSecurity';
        export const insertPermission = 'DataAdmin:IndexationProfileSecurity';
        export const readPermission = 'Read:IndexationProfileSecurity';
        export const updatePermission = 'DataAdmin:IndexationProfileSecurity';

        export declare const enum Fields {
            IndexationProfileCode = "IndexationProfileCode",
            SecurityId = "SecurityId",
            IndexCode = "IndexCode",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            DefaultSortOrder = "DefaultSortOrder",
            IndexationProfileName = "IndexationProfileName",
            IndexationProfileIndexationInstanceId = "IndexationProfileIndexationInstanceId",
            IndexationProfileEffectiveDate = "IndexationProfileEffectiveDate",
            IndexationProfileValidFrom = "IndexationProfileValidFrom",
            IndexationProfileValidTo = "IndexationProfileValidTo",
            IndexationProfileShortName = "IndexationProfileShortName",
            IndexationProfileRowId = "IndexationProfileRowId",
            IndexationProfileDefaultSortOrder = "IndexationProfileDefaultSortOrder",
            SecurityCode = "SecurityCode",
            SecurityName = "SecurityName",
            SecurityRowId = "SecurityRowId",
            IndexName = "IndexName",
            IndexLocalCurrencyCode = "IndexLocalCurrencyCode",
            IndexTypeCode = "IndexTypeCode",
            IndexPriceSource1 = "IndexPriceSource1",
            IndexPriceSource1Id = "IndexPriceSource1Id",
            IndexPriceSource2 = "IndexPriceSource2",
            IndexPriceSource2Id = "IndexPriceSource2Id",
            IndexFxOtherCurrency = "IndexFxOtherCurrency",
            IndexRowId = "IndexRowId",
            IndexDefaultSortOrder = "IndexDefaultSortOrder"
        }
    }
}
